import { render } from "./HelloWorld.vue?vue&type=template&id=40ff32c4&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-40ff32c4"

export default script